import React, { Component } from 'react';
//import './ReactotronConfig'

import Ecran180 from './Ecran180'
import { getBuildVersion } from './Tools.js'

import './App.css';


/* APP ECRAN D'ACCUEIL, RESPONSIVE
*/ 


class App extends Component {

  constructor(props) {

    super(props);

    this.state = {    
      /* */
      appVersion : 0,
      playing180: false,
      isPortrait: false
    }
  }

  componentDidMount() {


    getBuildVersion( (v) => {
      this.props.logFn("App:componentDidMount(): appVersion : "+v);
      this.setState( { appVersion : v } );
    })

    this.setState( { isPortrait : window.matchMedia("all and (orientation: portrait)").matches } );

    const mql = window.matchMedia("all and (orientation: portrait)");
    mql.addListener(this.screenTest);
  }

  screenTest = (e) =>
  {
    if (e.matches) {
      //console.log("portrait");
      this.setState( { isPortrait : true } );
    }else
    {
      //console.log("pas portrait");
      this.setState( { isPortrait : false } );
    }
  }

  componentWillUnmount() {

    // par exemple, clearInterval
  }  

  _start180 = () =>
  {
    this.setState( { playing180 : true } );
  }


  render() {

    const { config, logFn } = this.props;

    const { appVersion,playing180, isPortrait } = this.state;

    let t_images = [];
    for(let i=1;i<8;i++)
    {
      t_images.push( <div className="ImageRef" key={i} style={ { backgroundImage: "url('intro_web/shot_"+ i + ".jpg')" } }></div> );
    }

    return (
      <div className="App">
        {/* (isPortrait && !playing180) &&
          <React.Fragment>
            <div className="AppBackground"></div>
            <div className="popupTourner"><p>Tourner votre écran !</p></div>    
          </React.Fragment>
        */ }
        { !playing180 &&
          <React.Fragment>
          <div className="wrapper">
            <div className="HeaderPhoto1 section parallax">
              {/*<div className="Logo80"></div>*/}
              <div className="LogoRHBleu"><img src="intro_web/logo_rh2.png"></img></div>
            </div>

          <div className="Header_titre">
            <div className="titreBleu">CHEMINS DE FER : UNE AVENTURE HUMAINE</div>
          </div>
          <div className="ContenuIntro">
            <div className="ContenuIntroG">
              <p>Du 25 septembre au 14 octobre 2018, à l'occasion des festivités pour les 80 ans de sa création, la SNCF a lancé un train exposition qui fit le tour de France en 15 étapes de Paris à Mulhouse.</p>
              <p>L’association Rails et histoire a été associé à ce projet et une voiture de ce « Train de l’innovation » lui a été réservée. Pour l’occasion, l’association a notamment souhaité créer un film interactif historique retraçant 180 ans d’histoire des chemins de fer et s’est appuyée sur l’expertise et le savoir-faire de Cent millions de Pixels pour la réalisation.</p>
              <p>L’expérience virtuelle a été pensée de façon à permettre au public de s’immerger dans la longue et belle histoire des chemins de fer à travers différents thèmes. Ainsi sont abordés les prémices du ferroviaire, les métiers, le tourisme ou la création des compagnies.</p>
              <p>Au cours de notre parcours, cette animation a rencontré un vif succès auprès du public et nous avons donc souhaité prolonger ce partage avec la mise en ligne de ce beau projet.</p>
            </div>
            <div className="ContenuIntroD">
            <div className="ZoneViolet">
              <div className="RondGo" onClick={ this._start180 }></div>
              <p>Vous êtes prêts ?<br/>
              cliquez ici pour démarrer l’aventure...</p>
              </div>
              <div className="ZonePicto"></div>Le film interactif a été conçu pour etre consulté sur une table tactile. Pour une expérience optimale, nous vous invitons à utiliser un ordinateur ou une tablette utilisant un navigateur récent (Chrome, Firefox, Edge, Safari). 
N’oubliez pas non plus de brancher vos enceintes.
            </div>
          </div>
          <div className="ContainerImages">{ t_images } </div>
{/*          <div className="HeaderPhoto2 section parallax"></div>*/}
          <div className="Header_credits">CREDITS</div>
          <div className="ContenuCredits">
            <div className="demiCredit">
             <p><span className="texteVert">Maitrise d’ouvrage et direction éditoriale</span><br/><br/>
             <a href="https://www.ahicf.com/"><img src="intro_web/logo_rh2.png"></img></a>
             </p>
             <p><span className="texteVert">Iconographie</span><br/><br/>
              Service Archives et Documentation SNCF (SARDO)<br/>
             <img src="intro_web/logo_sncf.png" width="128"></img></p>
              <p><span className="texteVert">Textes</span><br/><br/>
              Sylvère Aït Amour, Claire Ollier, Cécile Hochard et Bruno Carrière</p>
              <p><span className="texteVert">Recherches iconographiques</span><br/><br/>
              Claire Ollier (Rails & histoire) et Sandra Fulmer (SNCF SARDO)</p>
            </div>
            <div className="demiCredit">
            <p><span className="texteVert">Conception et réalisation</span><br/><br/>
            <a href="http://centmillionsdepixels.com/"><img src="intro_web/logo_cmdp.png"></img></a></p>
            <p><span className="texteVert">Développement</span><br/><br/>
            <a href="http://www.mgdesign.fr/"><img src="intro_web/logo_mgd.png"></img></a></p>
            <p><span className="texteVert">Sonorisation</span><br/><br/>
            <a href="https://www.sound4museum.com/"><img src="intro_web/logo_sfm.png"></img></a></p>
            </div>
          </div>
          <div className="HeaderPhoto3 section parallax"></div>
          </div>

          </React.Fragment>
        }
        { playing180 &&       
            <Ecran180 appVersion={ appVersion } config={ config } logFn={logFn} />                 
        }
      </div>
    );  


  }

}

/* ----------------------- out of THIS world .... ----------------------- */

export default App;



// WEBPACK FOOTER //
// ./src/App.js